export default "__VITE_ASSET__DMfxKAVp__ 374w";